var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"viewer",staticClass:"fr-view",domProps:{"innerHTML":_vm._s(_vm.content || _vm.emptyText)}})}
var staticRenderFns = []

export { render, staticRenderFns }